import React from "react";
import Community from "../components/Community";

const CommunityPage = () => <Community />;

export default CommunityPage;
